import { isNumber } from 'lodash';

export function trackById<V, T extends { id?: V }>(_: number, item: T) {
  return item.id;
}

export function isNumberOrEmpty(value?: number): boolean {
  return isNumber(value) || !value;
}

export function isNotEmpty<T>(value: T): boolean {
  return isNumber(value) || !!value;
}
